import React from "react";
import { useNavigate } from "react-router-dom";
import SocialWeekBuilder from "../SocialWeekBuilder";

export default function SocialWeek() {
  const navigate = useNavigate();
  return <SocialWeekBuilder onBack={() => navigate("/app")} />;
}
